function e(t, n) {
  return t instanceof Date ? new t.constructor(n) : new Date(n);
}
export {
  e as constructFrom,
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/constructFrom.js
// module id = 48
// module chunks = 41